import React, { FC } from 'react';
import { FontAwesomeIcon } from 'components/shared/icons/FontAwesomeIcon/FontAwesomeIcon';
import { LoaderProps } from 'components/shared/loaders/Loader/Loader.types';

export const Loader: FC<LoaderProps> = (props) => {
  return <FontAwesomeIcon name={'cog'} animation={'spin'} {...props} />;
};
